exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/midac/midac-live/app/src/app/components/terms-of-use-dialog/terms-of-use-dialog.component.scss
// module id = ../../../../../src/app/components/terms-of-use-dialog/terms-of-use-dialog.component.scss
// module chunks = main